import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function AdminRoute({ element }) {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#E8F4FD', fontSize: '24px',
      }}>
        Loading... ⏳
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
  if (user?.role !== 'admin') return <Navigate to="/" replace />;

  return element;
}

export default AdminRoute;
